
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(8 9)"}},[_c('rect',{attrs:{"width":"5","height":"9.222","x":"32.458","y":"9.417","fill":"#F4FBFE","stroke":"#5FB8EE","stroke-width":"2","rx":"1"}}),_c('path',{attrs:{"fill":"#F4FBFE","stroke":"#5FB8EE","stroke-linejoin":"round","stroke-width":"2","d":"M41.367 43.552v-21.35c0-.428-.228-.824-.598-1.04L6.81 1.403v42.15"}}),_c('path',{attrs:{"fill":"#FFF","d":"M28 30h7v13h-7z"}}),_c('rect',{attrs:{"width":"7.619","height":"16.236","x":"12.827","y":"20.038","fill":"#FFF","stroke":"#5FB8EE","stroke-width":"2","rx":"1.403"}}),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-width":"2","d":"M.007 43.687h48M5.014.2l38.875 22.445"}}),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M26.918 39.376V28.164h7.458v11.164"}}),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-width":"2","d":"M24.452 43.552v-2.624a1 1 0 011-1h10.39a1 1 0 011 1v2.624h0"}})]),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"square","stroke-width":"2","d":"M21.924 39.16h5.611"}})])])
          )
        }
      }
    